import MicroModal from "micromodal";

(function () {
  MicroModal.init();
})();
